import { createFileRoute } from "@tanstack/react-router"
import { UserDetail } from "@/features/user-management/components"
import { listCountries } from "@/features/user-management/server/userManagement"

export const Route = createFileRoute("/(authenticated)/settings/users/$userId")({
  loader: async ({ params, context }) => {
    const { getUserDetail } = await import("@/features/user-management/server/userManagement")
    const data = await getUserDetail({ data: { userId: params.userId } })
    // Prefetch countries for add access modal
    await context.queryClient.prefetchQuery({
      queryKey: ["countries"],
      queryFn: () => listCountries({}),
    })
    return data
  },
  component: () => {
    const { userId } = Route.useParams()
    const loaderData = Route.useLoaderData()
    return <UserDetail userId={userId} initialData={loaderData} />
  },
})
